import { render, staticRenderFns } from "./MultiselectAvatarTag.vue?vue&type=template&id=4303f7d6"
import script from "./MultiselectAvatarTag.vue?vue&type=script&lang=ts"
export * from "./MultiselectAvatarTag.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/codebuild/output/src4020427597/src/jobbliss-app-vue/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('4303f7d6')) {
      api.createRecord('4303f7d6', component.options)
    } else {
      api.reload('4303f7d6', component.options)
    }
    module.hot.accept("./MultiselectAvatarTag.vue?vue&type=template&id=4303f7d6", function () {
      api.rerender('4303f7d6', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/autocompleteMultiselects/MultiselectAvatarTag.vue"
export default component.exports